/**
 * Filtros de relatório (GET /relatorios) → campos do formulário ICMS-ST.
 * Variáveis no banco podem usar $, $F{}, $P{}, ${}.
 */

export const CHAVES_ICMS_ST = {
  dataInicial: "dataInicial",
  dataFinal: "dataFinal",
  notasSaida: "notasSaida",
  prodId: "prodId",
};

const ORDEM_CAMPOS_DINAMICOS = [
  CHAVES_ICMS_ST.dataInicial,
  CHAVES_ICMS_ST.dataFinal,
  CHAVES_ICMS_ST.notasSaida,
  CHAVES_ICMS_ST.prodId,
];

/**
 * @param {string|undefined|null} variavel
 * @returns {'dataInicial'|'dataFinal'|'notasSaida'|'prodId'|null}
 */
export function normalizarVariavelParaChave(variavel) {
  if (variavel == null || String(variavel).trim() === "") return null;
  let s = String(variavel).trim();
  const braced = s.match(/^\$\{([^}]+)\}$/);
  if (braced) s = braced[1];
  const fp = s.match(/^\$[FP]\{([^}]+)\}$/i);
  if (fp) s = fp[1];
  s = s.replace(/^\$+/, "").trim();
  const lower = s.toLowerCase();

  if (lower === "dt_inicial" || lower === "data_inicial") {
    return CHAVES_ICMS_ST.dataInicial;
  }
  if (lower === "dt_final" || lower === "data_final") {
    return CHAVES_ICMS_ST.dataFinal;
  }
  if (lower === "notas_saida" || lower === "p_notas_saida") {
    return CHAVES_ICMS_ST.notasSaida;
  }
  if (
    lower === "prod_id" ||
    lower === "p_prodid" ||
    lower === "p_prod_id"
  ) {
    return CHAVES_ICMS_ST.prodId;
  }
  return null;
}

/**
 * Mantém o primeiro filtro por chave lógica (ex.: duas linhas $notas_saida).
 * @param {Array<{ nome?: string, variavel?: string }>|undefined} filtros
 * @returns {Array<{ nome?: string, variavel?: string }>}
 */
export function deduplicarFiltrosIcmsSt(filtros) {
  if (!Array.isArray(filtros)) return [];
  const visto = new Set();
  const saida = [];
  for (const f of filtros) {
    const chave = normalizarVariavelParaChave(f?.variavel);
    if (!chave || visto.has(chave)) continue;
    visto.add(chave);
    saida.push(f);
  }
  return saida;
}

/**
 * Lista ordenada de chaves dinâmicas a exibir (sem grupo/empresa).
 * @param {Set<string>} chaves
 * @returns {string[]}
 */
export function ordenarChavesDinamicasIcmsSt(chaves) {
  return ORDEM_CAMPOS_DINAMICOS.filter((k) => chaves.has(k));
}

/**
 * Se `filtros` vazio/indefinido: todos os campos dinâmicos (comportamento legado).
 * Caso contrário: só chaves reconhecidas após deduplicação.
 * @param {Array|undefined|null} filtrosRelatorio
 * @returns {Set<string>}
 */
export function getChavesExibicaoIcmsSt(filtrosRelatorio) {
  if (!Array.isArray(filtrosRelatorio) || filtrosRelatorio.length === 0) {
    return new Set(ORDEM_CAMPOS_DINAMICOS);
  }
  const dedup = deduplicarFiltrosIcmsSt(filtrosRelatorio);
  const chaves = new Set();
  for (const f of dedup) {
    const c = normalizarVariavelParaChave(f.variavel);
    if (c) chaves.add(c);
  }
  return chaves;
}

/**
 * Rótulo vindo do cadastro ou fallback.
 * `prodId` usa sempre "ID Produto" na UI (consistência).
 * @param {Array} filtrosDedup
 * @param {string} chave
 * @param {string} fallback
 */
export function rotuloFiltroIcmsSt(filtrosDedup, chave, fallback) {
  if (chave === CHAVES_ICMS_ST.prodId) {
    return "ID Produto";
  }
  const f = filtrosDedup.find(
    (x) => normalizarVariavelParaChave(x?.variavel) === chave
  );
  const nome = f?.nome && String(f.nome).trim();
  return nome || fallback;
}
